// import Autosuggest from 'react-autosuggest'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import config from 'config'
import {Row, Col} from 'react-flexbox-grid'
// import * as searchActions from 'redux/modules/search'
import {
  ContainerDivs,
  Works,
  Link,
  LinkIcon,
  SocialButtons,
  GetStartedInput,
  BenchmarkGrid,
  TargetDateGrid,
  FamilyGrid,
  AboutBanner,
  ScreenedCompanies,
  AutocompleteSearch,
  SrOnly,
  AykCtaPanel,
} from '../../components'
import format from '../../helpers/format'
// import Loader from 'react-loader'

const Styles = require('./Home.css')

@CSSModules(Styles, {allowMultiple:true})
export default class Home extends Component {
  constructor() {
    super()
    this.state = {}
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  renderBanner = () => {
    const aysLogo = require( '../../../static/images/AsYouSow_Logo_color.svg' )
    return (
      <div styleName='banner-wrapper'>
        <div styleName='banner-wrapper-gray'>
          <div styleName='banner-container'>
            <div styleName='banner-container-inner'>
              <div styleName='image-banner-green'>
                
                <div styleName='image-banner-headline'>
                  Don't want your retirement savings invested in the <Link to={config.routes.about} ><span styleName='image-banner-headline-emph-2'>prison industrial complex</span></Link>?
                </div>

                { /* <div styleName='image-banner-headline'>
                  We have the power<br/>to
                  cut <span styleName='image-banner-headline-emph-1'>financial
                  ties</span><br/>to
                  the <Link to={config.routes.about} ><span styleName='image-banner-headline-emph-2'>prison industrial complex</span></Link>
                </div> */ }

                <div styleName='banner-btn-box-border'>
                  <div styleName='banner-tagline'>
                    Find mutual funds and ETFs that avoid the prison industrial complex
                  </div>
                  <div styleName='banner-btn-wrap'>
                    <Link
                      to={config.routes.clean}
                      bigbutton
                      title='Get started'>
                      <div>
                        Top-scoring funds<LinkIcon />
                      </div>
                    </Link>
                  </div>
                </div>

                <div styleName='search-box-border'>
                  <div styleName='banner-tagline-2'>
                    Search funds from your 401(k), IRA, or portfolio
                  </div>
                  <AutocompleteSearch />
                </div>

                <div styleName='banner-btn-wrap'>
                  <div styleName='logo-tagline'>A project of</div>
                  <Link to={config.links.ays} title='As You Sow'>
                    <img
                      styleName='logo-ays'
                      src={aysLogo}
                      alt='As You Sow'
                    />
                    <SrOnly>As You Sow</SrOnly>
                  </Link>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const link = config.domain
    const message = config.shareMessage
    // const iyvLogo = require( '../../../static/images/iyv-logo-project-of-2021.jpg' )
    return (
      <div styleName="main">
        { this.renderBanner() }

        <AykCtaPanel />
        
        {/* <div styleName='img-banner-wrapper' /> */}
        <div styleName='x-lede'>
          <div styleName='x-lede-inner'>
            <div styleName='lede'>
              <p>
                <strong>Prison Free Funds can help you find out if your money is invested in private prisons, exploitative prison labor, and immigration detention centers.</strong>
              </p>
              <p>
                For-profit firms have flooded money into prison and detention center infrastructure and services, and have used industry associations to lobby for harsher policing and longer sentencing, even for non-violent offenders. Mass incarceration, a manifestation of racist policy, is particularly devastating for poor communities, immigrants, people of color, and their families. Inmates work for pennies per hour while their families pay exorbitant fees to keep them supplied with bare necessities. Powerful private equity interests and corporations are deeply involved with the militarization of the U.S.-Mexico border and the policing of immigration.
              </p>
              <p>
                Using this free online tool and our <Link to={config.routes.toolkit} xstrong title='Prison free action toolkit'>action toolkit</Link>, you can harness your economic power to shift your savings away from these systems of oppression and exploitation.
              </p>
              <div style={{'textAlign':'center'}}>
                <Link to={config.routes.clean} title='Get started' bigbutton>
                  Get started<LinkIcon />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <br/>
        <br/>
        <br/>

        {/* <SocialButtons message={message} link={link} /> */}
        <Works/>
        {/* <GetStartedInput /> */}

        <br/>
        <br/>
        <br/>

        <div styleName='x-lede'>
          <div styleName='x-lede-inner'> 
            <Row styleName='lower-lede-cols'>
              <Col xs={12} sm={12} md={12} styleName='lower-lede-col-2'>
                <div styleName='small-title'>
                  The prison and border industries
                </div>
                <p>
                  <strong>Prison Free Funds</strong> focuses on two aspects of the prison industrial complex: companies involved in the prison industry (such as private for-profit prison operators and prison services providers), and companies involved in the militarization of borders and the policing of immigration.
                </p>
                { /* The company-level research is provided by the <Link to={'https://investigate.afsc.org/'} alt={'American Friends Service Committee'} xstrong>American Friends Service Committee</Link>, a Quaker organization devoted to service, development, and peace programs throughout the world. */} 
                { /* <ScreenedCompanies /> */ }
                <div style={{'textAlign': 'center'}}>
                  <Link to={config.routes.companies} bigbutton>
                    See companies<LinkIcon />
                  </Link>
                </div>

              </Col>
            </Row>
          </div>
        </div>

        <br/>
        <br/>
        <br/>

        { /* <BenchmarkGrid /> */ }
        { /* <TargetDateGrid /> */ }
        { /* <GetStartedInput /> */ }
        { /* <FamilyGrid /> */ }
        { /* <GetStartedInput /> */ }

        <ContainerDivs>
          <AboutBanner />
        </ContainerDivs>
      </div>
    )
  }
}

